<template>
  <div class="row mycontainer">
    <div class="col-md-6 text-left mx-5">
      <h1>快一點開新店WEB版本</h1>
      <p>
        1. 下載開店檔案<a href="https://drive.google.com/drive/u/6/folders/1VFV5lFqfnKLJ3cXefcJBCGMoBNPiuEeD"
          >https://drive.google.com/drive/u/6/folders/1VFV5lFqfnKLJ3cXefcJBCGMoBNPiuEeD</a
        >
      </p>
      <p>2. 請留意EAA帳戶名稱與Email不可重複</p>
      <p>3. richmenu的設定可參考gaa後台幾種樣板名稱</p>
      <p>
        4. LINE類型請參考：<a
          href="https://developers.line.biz/api/v1/at/category/parent?country_code=TW"
          target="_blank"
          >母分類</a
        >和<a
          href="https://developers.line.biz/api/v1/at/category/child?country_code=TW"
          target="_blank"
          >子分類</a
        >
      </p>
      <p>4. 按方向鍵「右鍵」可繼續步驟</p>
      <h2>選擇環境</h2>
      <select v-model="envSelected">
        <option
          v-for="(option, index) in envOptions"
          :key="index"
          :selected="index === 0"
          >{{ option }}</option
        >
      </select>
      <span>Selected: {{ envSelected }}</span>
      <p>已選擇環境參數 {{ envSelected }}</p>
      <p v-if="envSelected && envProfiles[envSelected]">
        露出網域(LINE Login Callbacks):
        {{ JSON.stringify(envProfiles[envSelected].callbackUrls) }}
      </p>
      <p v-if="envSelected && envProfiles[envSelected]">
        菜單入口 LIFF: {{ envProfiles[envSelected].menuLiff }}
      </p>
      <p v-if="envSelected && envProfiles[envSelected]">
        訂單查詢 LIFF: {{ envProfiles[envSelected].orderLiff }}
      </p>
      <p v-if="envSelected && envProfiles[envSelected]">
        內用菜單 LIFF: {{ envProfiles[envSelected].eatInLiff }}
      </p>
      <h2>開店步驟</h2>
      <div class="row">
        <div class="col-md-12">
          <h4>Provider的連結</h4>
        </div>
        <div class="col-md-6">
          <textarea
            v-model="curldata"
            name="curldata"
            form="saveform"
            placeholder="curl"
            rows="10"
            cols="50"
          ></textarea>
        </div>
        <div class="col-md-5">
          <p>
            1. 請先登入<a
              href="https://developers.line.biz/console/"
              target="_blank"
              >LINE Developer</a
            >
          </p>
          <p>2. 手動建立一個Provider</p>
          <p>
            3. 建立好以後，執行：(mac) `Cmd` + `Option` + `i` 叫出開發者console
            / (window) `Ctrl` + `Shift` + `i`
          </p>
          <p>4. 切換到Network分頁，點選左上角的清空選項，讓Log乾淨一點</p>
          <p>
            5. 再次點擊要建立帳號的Provider，會看到Network的第一個Request是
            `?providerId=xxxx`，在上面按下右鍵 > Copy > Copy as cURL
          </p>
          <p>6. 貼入左方Provider方格</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>Bot編輯頁面連結</h4>
        </div>
        <div class="col-md-6">
          <textarea
            v-model="botdata"
            name="botdata"
            form="saveform"
            placeholder="curl"
            rows="10"
            cols="50"
          ></textarea>
        </div>
        <div class="col-md-5">
          <p>
            6. 請進入<a href="https://manager.line.biz/" target="_blank"
              >LINE Official Account Manager</a
            >
          </p>
          <p>
            7. 清空Network分頁後，點擊Accounts，複製第一個Request
            `cmsUser`，在上面按下右鍵 > Copy > Copy as cURL
          </p>
          <p>8. 貼入左方Bot編輯方格</p>
        </div>
      </div>

      <h3 class="mb-3">貼好資訊，按下下方按鈕取得LINE權限</h3>
      <button v-on:click="auth()" :disable="blockAll">
        取得LINE開店權限
      </button>

      <div v-if="step > 0">
        <h3>上傳開店檔案</h3>
        <input @change="fileChange" name="excelfile" type="file" id="myFile" />
        <button v-on:click="submitFile()">上傳開店檔案</button>
        <button v-on:click="submitFile(1)">修正開店檔案</button>
      </div>

      <!-- <button v-if="step > 1" v-on:click="createMsgChannel()">
        在 {{ this.provider.name }} 建立Message API Channel
      </button> -->
    </div>
    <div class="col-md-5">
      <h3 class="mb-3">操作記錄</h3>
      <button v-on:click="responseMessages = []">清除記錄</button>
      <div id="responseBlock" class="text-left">
        <div v-for="(theLog, index) in responseMessages" :key="index">
          <div v-if="theLog.type === 'info'">
            <p style="color: #000099;">{{ index }} {{ theLog.message }}</p>
          </div>
          <div v-else>
            <b style="color: #aa0000;">{{ theLog.message }}</b>
            <p style="color: #aa0000;">{{ theLog.stack }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  name: "Home",
  data() {
    return {
      envOptions: [
        "QC K8 Prod",
        "QC DEV",
        "QC K8 Staging",
        "QC K8 Beta",
        "APTG Staging",
        "APTG Prod",
        "Lifeplus Prod",
        "Medlight Prod",
        "T2C Prod"
      ],
      envSelected: "QC K8 Prod",
      envProfiles: {
        "QC DEV": {
          qcApi: "",
          qcaApi: "",
          menuLiff:
            "https://qc-dev.iiot.io/line/views/liff/liff2-menu",
          orderLiff: "https://eats-staging.quickclick.cc/orders",
          eatInLiff:
            "https://qc-dev.iiot.io/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://eats-staging.quickclick.cc",
            "https://eats-staging.quickclick.cc/orders",
            "https://qc-dev.iiot.io/line/views/liff/liff2-menu",
          ],
        },
        "QC K8 Staging": {
          qcApi: "",
          qcaApi: "",
          menuLiff:
            "https://line-staging.quickclick.cc/line/views/liff/liff2-menu",
          orderLiff: "https://eats-staging.quickclick.cc/orders",
          eatInLiff:
            "https://line-staging.quickclick.cc/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://line-staging.quickclick.cc/line/views/liff/liff2-menu",
            "https://eats-staging.quickclick.cc",
            "https://eats-staging.quickclick.cc/orders",
          ],
        },
        "QC K8 Beta": {
          qcApi: "",
          qcaApi: "",
          menuLiff:
            "https://line-beta.quickclick.cc/line/views/liff/liff2-menu",
          orderLiff: "https://eats-beta.quickclick.cc/orders",
          eatInLiff:
            "https://line-beta.quickclick.cc/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://line-beta.quickclick.cc/line/views/liff/liff2-menu",
            "https://eats-beta.quickclick.cc",
            "https://eats-beta.quickclick.cc/orders",
          ],
        },
        "QC K8 Prod": {
          menuLiff: "https://line.quickclick.cc/line/views/liff/liff2-menu",
          orderLiff: "https://eats.quickclick.cc/orders",
          eatInLiff: "https://line.quickclick.cc/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://eats.quickclick.cc",
            "https://eats.quickclick.cc/orders",
            "https://quickclick.cc/line/views/liff/liff2-menu",
            "https://line.quickclick.cc/line/views/liff/liff2-menu",
            "https://line-beta.quickclick.cc/line/views/liff/liff2-menu",
            "https://eats-beta.quickclick.cc",
            "https://eats-beta.quickclick.cc/orders",
          ],
        },
        "APTG Staging": {
          menuLiff:
            "https://aptg-line-staging.quickclick.cc/line/views/liff/liff2-menu",
          orderLiff: "https://aptg-eats-staging.quickclick.cc/orders",
          eatInLiff:
            "https://aptg-line-staging.quickclick.cc/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://aptg-eats-staging.quickclick.cc",
            "https://aptg-eats-staging.quickclick.cc/orders",
            "https://aptg-line-staging.quickclick.cc/line/views/liff/liff2-menu",
          ],
        },
        "APTG Prod": {
          menuLiff: "https://aptg-line.wifiotg.com/line/views/liff/liff2-menu",
          orderLiff: "https://aptg-eats.wifiotg.com/orders",
          eatInLiff:
            "https://aptg-line.wifiotg.com/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://aptg-eats.wifiotg.com",
            "https://aptg-eats.wifiotg.com/orders",
            "https://aptg-line.wifiotg.com/line/views/liff/liff2-menu",
          ],
        },
        "Lifeplus Prod": {
          menuLiff:
            "https://lifeplus-line.wifiotg.com/line/views/liff/liff2-menu",
          orderLiff: "https://lifeplus-eats.wifiotg.com/orders",
          eatInLiff:
            "https://lifeplus-line.wifiotg.com/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://lifeplus-eats.wifiotg.com",
            "https://lifeplus-eats.wifiotg.com/orders",
            "https://lifeplus-line.wifiotg.com/line/views/liff/liff2-menu",
          ],
        },
        "Medlight Prod": {
          menuLiff:
            "https://medlight-line.wifiotg.com/line/views/liff/liff2-menu",
          orderLiff: "https://medlight-eats.wifiotg.com/orders",
          eatInLiff:
            "https://medlight-line.wifiotg.com/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://medlight-eats.wifiotg.com",
            "https://medlight-eats.wifiotg.com/orders",
            "https://medlight-line.wifiotg.com/line/views/liff/liff2-menu",
          ],
        },
        "T2C Prod": {
          menuLiff:
            "https://torder-line.turn2cloud.com/line/views/liff/liff2-menu",
          orderLiff: "https://torder-eats.turn2cloud.com/orders",
          eatInLiff:
            "https://torder-line.turn2cloud.com/line/views/liff/liff2-eatin",
          callbackUrls: [
            "https://torder-line.turn2cloud.com",
            "https://torder-line.turn2cloud.com/orders",
            "https://torder-line.turn2cloud.com/line/views/liff/liff2-menu",
          ],
        },
      },
      step: 0,
      steps: [
        "auth",
        "submitFile",
        "wizard",
        // "createLoginChannel",
        // "createMsgChannel",
        // "enableBot",
        // "enableInstantResponse",
        // "enableWelcomeMessage",
        // "putLoginCallbacks",
        // "addMenuLiff",
        // "addOrderLiff",
        // "addEatInLiff",
        // "enableLineChannel",
        "checkWiFiOTG",
        "createWiFiOTG",
        "createQCAccount",
        "createQCBusiness",
        "updateAccountSI",
        // "updateAccountOA",
        "setAccountDefaultItem",
        // "getAccountParams",
        // "updateLineWebhook",
        // "verifyWebhook",
        // "enableWebhook",
        "wizardWorkerHandler",
        // "enableRichmenu",
      ],
      curldata: "",
      botdata: "",
      provider: {},
      longtermToken: {},
      channel: {},
      channelInfo: {},
      botInfo: {},
      loginChannel: {},
      menuLiff: "",
      orderLiff: "",
      eatInLiff: "",
      wifiotgBusinessId: null,
      responseMessages: [],
      devjson: "",
      botjson: "",
      formData: new FormData(),
      uuid: "",
      accounts: [],
      account: null, // 目前執行的account
      blockAll: false,
      shopCount: 0,
      loginCallbacks: false,
      loginEnabled: false,
    };
  },
  props: {
    msg: String,
  },
  created() {
    this.onKeyDown = this.onKeyDown.bind(this);
    document.addEventListener("keydown", this.onKeyDown);
  },
  destroyed() {
    document.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    funCall(funName) {
      this[funName]();
    },
    thisStep() {
      return this.steps[this.step];
    },
    runNext() {
      ++this.step;
      this.funCall(this.thisStep());
    },
    onKeyDown(e) {
      switch (e.keyCode) {
        case 39:
          if (!this.blockAll) {
            this.funCall(this.thisStep());
          }
          break;
        case 37:
          this.step--;
          this.responseMessages.push({
            type: "info",
            message: `執行步驟往前一步，按右鍵繼續執行 ${
              this.steps[this.step]
            }`,
          });
          break;
        // case 40:
        //   console.log("down");
        //   break;
      }
    },
    auth() {
      // 0
      this.blockAll = true;
      let self = this;
      // if (!this.curldata) {
      //   alert("請輸入Provider連結");
      //   return;
      // }

      // if (!this.botdata) {
      //   alert("請輸入Bot編輯頁面連結");
      //   return;
      // }


      self.responseMessages.push({
        type: "info",
        message: `WEB版本不用Provider 資訊`,
      });
      this.step = 1;
      this.blockAll = false;

      // fetch("/auth", {
      //   method: "POST",
      //   headers: {
      //     "content-type": "application/json",
      //   },
      //   body: JSON.stringify({
      //     curldata: this.curldata,
      //     botdata: this.botdata,
      //   }),
      // })
      //   .then((response) => {
      //     if (!response.ok) {
      //       let err = new Error(response.statusText);
      //       err.response = response;
      //       throw err;
      //     }
      //     return response.json();
      //   })
      //   .then((data) => {
      //     if (!data.devjson) {
      //       throw new Error(
      //         "無法成功解析LINE Developer授權資訊，請重新複製連結並重新送出"
      //       );
      //     }
      //     // if (!data.botjson) {
      //     //   throw new Error(
      //     //     "無法成功解析LINE Manager授權資訊，請重新複製連結並重新送出"
      //     //   );
      //     // }
      //     if (!data.provider) {
      //       throw new Error("無法成功取得Provider資訊");
      //     }
      //     this.devjson = data.devjson;
      //     this.botjson = data.botjson;
      //     this.provider = data.provider;
      //     console.log(JSON.stringify(this.provider));
      //     let today = new Date();

      //     self.responseMessages.push({
      //       type: "info",
      //       message: `[${today}] 取得認證資訊成功 - Provider: ${
      //         data.provider.name
      //       }(${data.provider.id}) 操作人: ${JSON.stringify(
      //         data.provider.members
      //       )}`,
      //     });
      //     this.step = 1;
      //     this.blockAll = false;
      //   })
      //   .catch((e) => {
      //     console.log("return failed ");
      //     if (e.response) {
      //       e.response.json().then(function (err) {
      //         self.responseMessages.push(err.error);
      //       });
      //     } else {
      //       self.responseMessages.push({
      //         type: "error",
      //         message: e.message,
      //         stack: e.stack,
      //       });
      //     }
      //     self.blockAll = false;
      //   });
    },
    fileChange(e) {
      console.log("file changed", e);
      this.formData = new FormData();
      this.formData.append("excelfile", e.target.files[0]); //放進上傳的檔案
    },
    wizard() {
      this.account = this.formatAccount(this.accounts[this.shopCount]);
      this.responseMessages.push({
        type: "info",
        message: `開始執行第 ${
          this.shopCount + 1
        } 間店，請點擊方向鍵「右鍵」繼續`,
      });

      this.step++;
    },
    formatAccount(account) {
      var data = {
        wifiotgEaaId: account["WiFiOTG_EAA_ID"],
        accountId: account["商店ID"],
        name: account["LINE點餐帳號名稱"],
        description: account["LINE點餐帳號描述"],
        // provider: {
        //   "id": global.query.providerId
        // },
        contactEmail: account["店家聯絡郵件"],
        contactPhone: account["店家聯絡電話"],
        eaaAccount: account["EAA登入帳戶名稱(唯一)"],
        eaaEmail: account["EAA登入Email(唯一)"],
        eaaPhone: account["申請人電話"],
        eaaPassword: account["EAA登入密碼"],
        shopAddress: account["商店地址"],
        richmenu: account["richmenu"],
        siAccountId: account["SI的ID(數字)"],
        invoice: account["統編"],
        businessName: account["商店名稱"],
        businessCode: account["商店代碼"],
        lineAt: {
          // LINE AT種類
          // https://developers.line.biz/api/v1/at/category/child?country_code=TW
          categoryId: account["LINE類型"].toString(),
        },
        privacyPolicyUrl: account["隱私政策網址"],
        termsOfUseUrl: account["使用條款網址"],
        fbUrl: account["FB連結"],
        googleReviewUrl: account["GoogleReview連結"],
        timeSetting: account["系統點餐時間"],
        timeSectorLength: account["餐點時間間距(分鐘)"],
        deliveryDistanceTh: account["最長外送距離(公里)"],
        deliveryQtyTh: account["最少外送數量(項)"],
        deliveryAmtTh: account["最低外送金額(元)"],
        resetTime: account["上架商品重置時間"],
        waitingTime: account["餐點準備時間(分鐘)"],
        isMobilePayment: account["啟用線上支付"],
        isLala: account["啟用lala外送"],
        isDeliveryPay: account["外送線上支付"],
        isDeliveryCash: account["外送現金付款"],
        isDelivery: account["啟用外送"],
        isToGoPay: account["外帶線上支付"],
        isToGoCash: account["外帶現金付款"],
        isToGo: account["啟用外帶"],
        isEatInPay: account["內用線上支付"],
        isEatInCash: account["內用現金付款"],
        isEatIn: account["啟用內用"],
        openingTime: account["公告營業時間"],
        menuLiffId: account["菜單LIFF"],
        orderLiffId: account["訂單LIFF"],
        eatInLiffId: account["內用LIFF"],
        oaBasicId: account["OA_BASIC_ID"],
      };
      this.responseMessages.push({
        type: "info",
        message: `[${new Date()}] ${JSON.stringify(data, null, 2)}`,
      });

      return data;
    },
    submitFile(isUpdate) {
      // step1
      console.log("the event ", this.formData);
      let self = this;
      fetch("/upload-excel", {
        // Your POST endpoint
        method: "POST",
        // headers: {
        //   // Content-Type may need to be completely **omitted**
        //   // or you may need something
        //   "Content-Type": "You will perhaps need to define a content-type here"
        // },
        body: this.formData, // This is your file object
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((success) => {
          console.log(success); // Handle the success response object
          let today = new Date();
          this.uuid = success.uuid;
          if (this.uuid) {
            self.responseMessages.push({
              message: `[${today}] 上傳檔案成功 - ${this.uuid}`,
              type: "info",
            });
            self.getUploadedJson(isUpdate);
          } else {
            let e = {
              message: `[${today}] 無法擷取上傳檔案，請確認已選擇正確的Excel檔案，或嘗試重新上傳`,
              type: "error",
            };
            self.responseMessages.push(e);
          }
        })
        .catch((e) => {
          console.log("return failed ");
          if (e.response) {
            e.response.json().then(function (err) {
              console.log("the err " + JSON.stringify(err));
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    getUploadedJson(isUpdate) {
      let self = this;
      self.responseMessages.push({
        message: `載入檔案資訊`,
        type: "info",
      });
      fetch("/upload/" + this.uuid, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((excelres) => {
          let today = new Date();
          self.responseMessages.push({
            type: "info",
            message: `[${today}] 成功取得上傳資料`,
          });
          this.accounts = excelres["開店資訊"];
          if (!this.accounts) {
            this.responseMessages.push({
              type: "error",
              message: "請確認Excel檔案格式，工作表名稱必須為「開店資訊」",
            });
            return;
          }
          this.responseMessages.push({
            type: "info",
            message: `取出 ${this.accounts.length} 間店家資訊，請按「右鍵」繼續`,
          });

          if (isUpdate) {
            this.account = this.formatAccount(this.accounts[this.shopCount]);
            console.log(JSON.stringify(this.account));
            this.responseMessages.push({
              type: "info",
              message: `已更新開店檔案，請按「右鍵」繼續`,
            });
          } // 更新就不跳步驟
          else {
            this.wifiotgBusinessId = null;

            ++this.step;
          }
        })
        .catch((e) => {
          console.log("return failed ");
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    createMsgChannel() {
      let body = this.account;
      this.blockAll = true;
      let self = this;
      if (!this.devjson) {
        alert("尚未獲得LINE Developer權限");
        return;
      }
      var jsonParams = {
        name: body.name,
        description: body.description,
        provider: {
          id: this.devjson.query.providerId,
        },
        contactEmail: body.contactEmail,
        // LINE AT種類
        // https://developers.line.biz/api/v1/at/category/child?country_code=TW
        lineAt: body.lineAt,
        privacyPolicyUrl: body.privacyPolicyUrl,
        termsOfUseUrl: body.termsOfUseUrl,
      };
      if (!body.lineAt) {
        this.responseMessages.push({
          type: "error",
          message: "缺乏必要資訊 - LINE@名稱",
        });
        return;
      }

      this.responseMessages.push({
        type: "info",
        message: `嘗試在 ${
          this.devjson.query.providerId
        } 建立LINE Messenger Channel - ${JSON.stringify(
          body.lineAt
        )}，這個動作比較久，請稍等`,
      });
      fetch("/message-api-channel", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: self.devjson,
          account: jsonParams,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.longtermToken = data.longtermToken;
          this.channel = data.channel;
          if (this.channel && this.channel.id) {
            this.responseMessages.push({
              type: "info",
              message: `建立 Channel ${this.channel.id}`,
            });
            this.runNext();
          } else {
            throw new Error("LINE Channel 建立失敗，請嘗試重新建立");
          }

          self.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    enableBot() {
      let self = this;
      this.blockAll = true;

      this.responseMessages.push({
        type: "info",
        message: `允許 Bot 授權，並取得Bot資訊 - ${this.channel.id}`,
      });
      fetch("/enable-bot", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          channelId: this.channel.id,
          botjson: this.botjson,
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.channel && data.channel.botConfiguration && data.botInfo) {
            this.channelInfo = data.channel;
            this.botInfo = data.botInfo;

            this.responseMessages.push({
              type: "info",
              message: `成功同意 bot 授權，並且取得bot資訊 ${JSON.stringify(
                data.botInfo
              )}`,
            });
            this.runNext();
          } else {
            throw new Error("無法授權 Bot 資訊");
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    createLoginChannel() {
      let body = this.formatAccount(this.accounts[0]); // 第一間為總店，Login資訊以此建立
      let self = this;

      if (this.loginChannel && this.loginChannel.id) {
        this.responseMessages.push({
          type: "info",
          message: `LINE Login Channel 已經建立，直接繼續`,
        });
        this.runNext();
        return;
      } else if (body.menuLiffId && body.orderLiffId && body.eatInLiffId) {
        this.responseMessages.push({
          type: "info",
          message: `偵測到Excel文件有提供菜單、訂單、內用等LIFF，略過建立新Login Channel`,
        });

        this.loginCallbacks = true;
        this.loginEnabled = true;
        this.runNext();
        return;
      }
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `建立LINE Login Channel - ${this.provider.name}`,
      });

      var jsonParams = {
        name: this.provider.name,
        description: this.provider.name,
        provider: {
          id: this.devjson.query.providerId,
        },
        contactEmail: body.contactEmail,
        // LINE AT種類
        // https://developers.line.biz/api/v1/at/category/child?country_code=TW
        lineAt: body.lineAt,
        privacyPolicyUrl: body.privacyPolicyUrl,
        termsOfUseUrl: body.termsOfUseUrl,
      };
      fetch("/login-channel", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          account: jsonParams,
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });
          this.loginChannel = data;
          this.runNext();
          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              self.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    putLoginCallbacks() {
      // let body = this.account;
      let self = this;
      if (this.loginCallbacks) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `LINE Login Channel 已啟用`,
        });
        this.runNext();
        return;
      }
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `開始更新LINE Login Callback`,
      });
      var jsonParams = this.envProfiles[this.envSelected];
      fetch("/login-channel/" + this.loginChannel.id + "/callbacks", {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          callbackUrls: jsonParams, // 先吃預設
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });
          this.loginCallbacks = true;
          this.runNext();
          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    addMenuLiff() {
      // let body = this.account;
      let self = this;

      if (this.menuLiff && this.menuLiff.liffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `套用剛剛建立好的菜單入口 - ${this.menuLiff.liffId}`,
        });
        this.runNext();
        return;
      }

      let body = this.account;
      if (body.menuLiffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `偵測到文件中提供菜單LIFF，直接套用 - ${body.menuLiffId}`,
        });
        this.menuLiff = { liffId: body.menuLiffId };
        this.runNext();
        return;
      }

      this.blockAll = true;

      this.responseMessages.push({
        type: "info",
        message: `新增 LINE Login LIFF - 菜單入口`,
      });
      fetch("/login-channel/" + this.loginChannel.id + "/liff", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          url: this.envProfiles[this.envSelected].menuLiff, // 先吃預設
          description: "菜單入口",
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.liffId) {
            this.responseMessages.push({
              type: "info",
              message: JSON.stringify(data, null, 2),
            });
            this.menuLiff = data; //  { "liffId": "1654329493-K0M7Gg7R" }
            this.runNext();
          } else {
            throw new Error(
              "無法成功取得LIFF ID, 請按右鍵重試 - " + JSON.stringify(data)
            );
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    addOrderLiff() {
      // let body = this.account;
      let self = this;
      if (this.orderLiff && this.orderLiff.liffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `套用剛剛建立好的訂單入口 - ${this.orderLiff.liffId}`,
        });
        this.runNext();
        return;
      }

      let body = this.account;
      if (body.orderLiffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `偵測到文件中提供菜單LIFF，直接套用 - ${body.orderLiffId}`,
        });
        this.orderLiff = { liffId: body.orderLiffId };
        this.runNext();
        return;
      }

      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `新增 LINE Login LIFF - 訂單查詢`,
      });
      fetch("/login-channel/" + this.loginChannel.id + "/liff", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          url: this.envProfiles[this.envSelected].orderLiff, // 先吃預設
          description: "訂單查詢",
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.liffId) {
            this.responseMessages.push({
              type: "info",
              message: JSON.stringify(data, null, 2),
            });
            this.orderLiff = data; //  { "liffId": "1654329493-K0M7Gg7R" }
            this.runNext();
          } else {
            throw new Error(
              "無法成功取得LIFF ID, 請按右鍵重試 - " + JSON.stringify(data)
            );
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    addEatInLiff() {
      // let body = this.account;
      let self = this;
      if (this.eatInLiff && this.eatInLiff.liffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `套用剛剛建立好的內用入口 - ${this.eatInLiff.liffId}`,
        });
        this.runNext();
        return;
      }

      let body = this.account;
      if (body.eatInLiffId) {
        // 已經建立了就繼續(多間店的時候)
        this.responseMessages.push({
          type: "info",
          message: `偵測到文件中提供內用LIFF，直接套用 - ${body.eatInLiffId}`,
        });
        this.eatInLiff = { liffId: body.eatInLiffId };
        this.runNext();
        return;
      }
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `新增 LINE Login LIFF - 內用菜單入口`,
      });
      fetch("/login-channel/" + this.loginChannel.id + "/liff", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          url: this.envProfiles[this.envSelected].eatInLiff, // 先吃預設
          description: "內用菜單入口",
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.liffId) {
            this.responseMessages.push({
              type: "info",
              message: JSON.stringify(data, null, 2),
            });
            this.eatInLiff = data; //  { "liffId": "1654329493-K0M7Gg7R" }
            this.runNext();
          } else {
            throw new Error(
              "無法成功取得LIFF ID, 請按右鍵重試 - " + JSON.stringify(data)
            );
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    enableWelcomeMessage() {
      let self = this;

      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `更新Bot Welcome Message`,
      });
      fetch(
        "/oa/" +
          this.channelInfo.botConfiguration.basicId +
          "/enable-welcome-msg",
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            botjson: this.botjson,
          }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    enableInstantResponse() {
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `更新Bot Instant Response`,
      });
      fetch(
        "/oa/" +
          this.channelInfo.botConfiguration.basicId +
          "/enable-instant-response",
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            botjson: this.botjson,
          }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    enableLineChannel() {
      let self = this;
      if (this.loginEnabled) {
        this.responseMessages.push({
          type: "info",
          message: `LINE Login Channel 已啟用，略過啟用API`,
        });
        this.runNext();
        return;
      }
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `啟用LINE Login Channel`,
      });
      fetch("/login-channel/" + this.loginChannel.id + "/enable", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.loginEnabled = true;

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    checkWiFiOTG() {
      let body = this.account;
      let self = this;
      this.blockAll = true;

      // 建立多間店的情況，EAA共用即可
      if (this.wifiotgEaaId && this.accounts.length > 1) {
        this.responseMessages.push({
          type: "info",
          message: `繼續將商店開立在同個WiFiOTG帳戶`,
        });
        this.runNext();
        this.blockAll = false;
        return;
      }

      this.responseMessages.push({
        type: "info",
        message: `確認WiFiOTG帳戶是否存在 - ${body.eaaAccount} - ${body.eaaEmail}`,
      });

      fetch("/wifiotg/check-user", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          username: body.eaaAccount,
          email: body.eaaEmail,
          uid: body.wifiotgEaaId,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && body.wifiotgEaaId) {
            // 更新
            this.responseMessages.push({
              type: "info",
              message: `更新帳戶，將建立Business於此WiFiOTG EAA帳戶下 - ${body.eaaEmail}`,
            });
            this.wifiotgEaaId = body.wifiotgEaaId;
            this.runNext();
            this.blockAll = false;
          } else if (!data && body.wifiotgEaaId) {
            this.blockAll = false;
            throw new Error(
              "請確認更新帳戶設定是否正確，如果不是要更新，請移除Excel中的WiFiOTG ID"
            );
          } else if (!data && !body.wifiotgEaaId) {
            // 可以
            this.responseMessages.push({
              type: "info",
              message: `無人使用此帳戶`,
            });
            this.runNext();
            this.blockAll = false;
          } else if (data && !body.wifiotgEaaId) {
            this.blockAll = false;
            throw new Error(
              "帳戶已被使用，若要加入既有帳戶，可更新Excel填入既有帳戶 username 與 uid"
            );
          }
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    createWiFiOTG() {
      let body = this.account;
      let self = this;
      this.blockAll = true;

      if (this.wifiotgEaaId) {
        this.responseMessages.push({
          type: "info",
          message: `新增商店到既有WiFiOTG EAA下`,
        });
        // 更新
        fetch(`/wifiotg-account/${this.wifiotgEaaId}/businesses`, {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            name: body.name,
            code: body.businessCode,
            email: body.contactEmail,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              let err = new Error(response.statusText);
              err.response = response;
              throw err;
            }
            return response.json();
          })
          .then((data) => {
            if (data && data.businessId) {
              this.responseMessages.push({
                type: "info",
                message: `成功建立 WiFiOTG 商店於 EAA ${body.eaaEmail} 帳戶下，Business ID為 ${data.businessId}`,
              });
              self.wifiotgBusinessId = data.businessId;
              this.runNext();
            } else {
              throw new Error(
                "無法成功建立 WiFiOTG 商店，請按「右鍵」嘗試重新建立 "
              );
            }

            this.blockAll = false;
          })
          .catch((e) => {
            if (e.response) {
              e.response.json().then(function (err) {
                this.responseMessages.push(err.error);
              });
            } else {
              self.responseMessages.push({
                message: e.message,
                stack: e.stack,
              });
            }
            self.blockAll = false;
          });
      } else {
        this.responseMessages.push({
          type: "info",
          message: `新增WiFiOTG帳戶與商店`,
        });
        fetch("/wifiotg-account", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((response) => {
            if (!response.ok) {
              let err = new Error(response.statusText);
              err.response = response;
              throw err;
            }
            return response.json();
          })
          .then((data) => {
            if (data && data.businessId) {
              this.responseMessages.push({
                type: "info",
                message: `成功建立 WiFiOTG EAA ${body.eaaEmail} 帳戶，Business ID為 ${data.businessId}`,
              });
              self.wifiotgBusinessId = data.businessId;
              this.runNext();
            } else {
              this.blockAll = false;
              throw new Error(
                "無法成功建立 WiFiOTG 商店，請按「右鍵」嘗試重新建立 "
              );
            }
          })
          .catch((e) => {
            if (e.response) {
              e.response.json().then(function (err) {
                this.responseMessages.push(err.error);
              });
            } else {
              self.responseMessages.push({
                message: e.message,
                stack: e.stack,
              });
            }
            self.blockAll = false;
          });
      }
    },
    createQCAccount() {
      let self = this;
      this.blockAll = true;
      let body = this.account;
      if (!this.wifiotgBusinessId) {
        this.responseMessages.push({
          type: "error",
          message: `尚未建立好 WiFiOTG 商店 ${this.wifiotgBusinessId}，無法建立快一點商店`,
        });
        return;
      }
      this.responseMessages.push({
        type: "info",
        message: `建立QC Account ${body.name}`,
      });
      // let channel = this.channelInfo;
      // let chatbot = this.botInfo;
      // console.log(JSON.stringify(this.channel));
      // console.log(JSON.stringify(this.channelInfo));
      // console.log(JSON.stringify(this.botInfo));
      let tempId = new Date().getTime();
      fetch("/qc-accounts", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
          account: {
            accountName: body.name,
            channelId: tempId,
            channelSecret: tempId, 
            channelAccessToken: tempId, 
            channelImageUrl: null,
            channelAddFriendUrl: null,
            channelBasicId: null,
            channelProviderId: null, // web版本不用providerId
            bossEmail: body.eaaEmail,
            bossPhone: body.eaaPhone,
            businessName: body.name,
            email: body.contactEmail,
            phone: body.contactPhone,
            address: body.shopAddress,
            shopId: this.wifiotgBusinessId,
            openingTime: body.openingTime,
            invoice: body.invoice,
            businessCode: body.businessCode,
            storeInfo: body.openingTime,
            isMobilePayment: body.isMobilePayment,
            isLala: body.isLala,
            isEatIn: body.isEatIn,
            isEatInCash: body.isEatInCash,
            isEatInPay: body.isEatInPay,
            isToGo: body.isToGo,
            isToGoCash: body.isToGoCash,
            isToGoPay: body.isToGoPay,
            isDelivery: body.isDelivery,
            isDeliveryCash: body.isDeliveryCash,
            isDeliveryPay: body.isDeliveryPay,
            FBUrl: body.fbUrl,
            googleReviewUrl: body.googleReviewUrl,
            waitingTime: body.waitingTime,
            resetTime: body.resetTime,
            deliveryAmtTh: body.deliveryAmtTh,
            deliveryQtyTh: body.deliveryQtyTh,
            deliveryDistanceTh: body.deliveryDistanceTh,
            timeSectorLength: body.timeSectorLength,
            timeSetting: body.timeSetting,
            siAccountId: body.siAccountId,
            menuLiffId: this.menuLiff.liffId,
            orderLiffId: this.orderLiff.liffId,
            eatInLiffId: this.eatInLiff.liffId,
          },
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.accountId) {
            this.accountId = data.accountId;
            // this.webhookUrl = data.webhookUrl; // 要根據不同平台處理 (好像可以改呼叫API?)
            // lineAccount.webhookUrl = lineAccount.webhookUrl.replace('app-staging.quickclick.cc', 'aptg-line-staging.quickclick.cc');

            this.responseMessages.push({
              type: "info",
              message: JSON.stringify(data, null, 2),
            });
            this.runNext();
          } else {
            console.log("create qc account failed " + JSON.stringify(data));
            throw new Error(
              "建立QC Account 失敗，無法取得正確的accountId。請確認 Excel 商店資料都有正確填入，按「右鍵」嘗試重新建立"
            );
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    createQCBusiness() {
      let self = this;
      this.blockAll = true;
      let body = this.account;
      if (!this.accountId) {
        this.responseMessages.push({
          type: "error",
          message: `尚未建立好 QC Account, 無法建立 QC Business`,
        });
        return;
      }
      this.responseMessages.push({
        type: "info",
        message: "建立QC Business - " + body.businessName,
      });
      // let channel = this.channelInfo;
      // let chatbot = this.botInfo;
      // console.log(JSON.stringify(this.channel));
      // console.log(JSON.stringify(this.channelInfo));
      // console.log(JSON.stringify(this.botInfo));
      let tempId = new Date().getTime();
      fetch(`/qc-accounts/${this.accountId}/businesses`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
          account: {
            accountName: body.name,
            channelId: tempId,
            channelSecret: tempId, 
            channelAccessToken: tempId, 
            channelImageUrl: null,
            channelAddFriendUrl: null,
            channelBasicId: null,
            channelProviderId: null, // web
            bossEmail: body.eaaEmail,
            bossPhone: body.eaaPhone,
            businessName: body.name,
            email: body.contactEmail,
            phone: body.contactPhone,
            address: body.shopAddress,
            shopId: this.wifiotgBusinessId,
            openingTime: body.openingTime,
            invoice: body.invoice,
            businessCode: body.businessCode,
            storeInfo: body.openingTime,
            isMobilePayment: body.isMobilePayment,
            isLala: body.isLala,
            isEatIn: body.isEatIn,
            isEatInCash: body.isEatInCash,
            isEatInPay: body.isEatInPay,
            isToGo: body.isToGo,
            isToGoCash: body.isToGoCash,
            isToGoPay: body.isToGoPay,
            isDelivery: body.isDelivery,
            isDeliveryCash: body.isDeliveryCash,
            isDeliveryPay: body.isDeliveryPay,
            FBUrl: body.fbUrl,
            googleReviewUrl: body.googleReviewUrl,
            waitingTime: body.waitingTime,
            resetTime: body.resetTime,
            deliveryAmtTh: body.deliveryAmtTh,
            deliveryQtyTh: body.deliveryQtyTh,
            deliveryDistanceTh: body.deliveryDistanceTh,
            timeSectorLength: body.timeSectorLength,
            timeSetting: body.timeSetting,
            siAccountId: body.siAccountId,
            menuLiffId: this.menuLiff.liffId,
            orderLiffId: this.orderLiff.liffId,
            eatInLiffId: this.eatInLiff.liffId,
          },
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.businessId) {
            this.responseMessages.push({
              type: "info",
              message: `建立QC Business成功 - ${data.businessId}`,
            });
            this.runNext();
          } else {
            throw new Error(
              "無法取得QC Business id, 請確認資料正確並按下「右鍵」重試"
            );
          }

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              this.responseMessages.push(err.error);
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    updateLineWebhook() {
      // line-channel/:channelId/webhook
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `更新Bot Webhook 位置 - ${this.webhookUrl}`,
      });
      fetch("/line-channel/" + this.channelInfo.id + "/webhook", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
          webhookUrl: this.webhookUrl,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    verifyWebhook() {
      // line-channel/:channelId/webhook
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `驗證Webhook - ${this.webhookUrl} (這步驟很容易失敗，失敗請按「右鍵」多測試幾次)`,
      });
      fetch("/line-channel/" + this.channelInfo.id + "/webhook-verify", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
          webhookUrl: this.webhookUrl,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    enableWebhook() {
      // line-channel/:channelId/webhook
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `啟用Webhook - ${this.webhookUrl}`,
      });
      fetch("/line-channel/" + this.channelInfo.id + "/webhook-enable", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          devjson: this.devjson,
          webhookUrl: this.webhookUrl,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    updateAccountSI() {
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `更新SI設定 - ${this.account.siAccountId}`,
      });
      fetch(`qc-accounts/${this.accountId}/si-account`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          siAccountId: this.account.siAccountId,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    updateAccountOA() {
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `更新OA設定 - 商店 ${this.accountId}`,
      });
      // let channel = this.channelInfo;
      // let chatbot = this.botInfo;
      let tempId = new Date().getTime();
      fetch(`qc-accounts/${this.accountId}/oa`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          accountId: this.accountId,
          lineChannelId: tempId, 
          lineChannelSecret: tempId, 
          lineChannelToken: tempId,
          lineChannelImageUrl: '',
          lineAddFriendUrl: '',
          lineBasicId: '', 
          lineProviderId: this.devjson.query.providerId,
          menuLiffId: this.menuLiff.liffId,
          orderLiffId: this.orderLiff.liffId,
          eatInLiffId: this.eatInLiff.liffId,
          styleAndFileName: this.account.richmenu,
          siAccountId: this.account.siAccountId,
          type: this.account.type || "catering",
        }),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    setAccountDefaultItem() {
      let self = this;
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `設定預設菜單到商店 ${this.accountId}`,
      });
      fetch(`qc-accounts/${this.accountId}/default-items`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({}),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          this.runNext();

          this.blockAll = false;
        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    getAccountParams() {
      let self = this;
      let body = this.account;
      if (!this.accountId && body.accountId) {
        this.accountId = body.accountId;
      }
      if (!this.accountId) {
        this.responseMessages.push({
          type: "error",
          message: `無法取得QC商店ID，新增帳戶失敗。如果是更新舊店，請確認Excel有既有商店ID，才能更新資訊`,
        });
        return;
      }
      this.blockAll = true;
      this.responseMessages.push({
        type: "info",
        message: `取得商店相關參數 ${this.accountId}`,
      });
      fetch(`qc-accounts/${this.accountId}/get-system-params`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({}),
      })
        .then((response) => {
          if (!response.ok) {
            let err = new Error(response.statusText);
            err.response = response;
            throw err;
          }
          return response.json();
        })
        .then((data) => {
          this.blockAll = false;

          this.responseMessages.push({
            type: "info",
            message: JSON.stringify(data, null, 2),
          });

          if (data.webhookUrlDomain && data.lineChannelId && data.randomCode) {
            if (data.webhookUrlDomain === 'line-aptg.wifiotg.com') {
              data.webhookUrlDomain = 'aptg-line.wifiotg.com';
            }
            if (data.webhookUrlDomain === 'line-lifeplus.wifiotg.com') {
              data.webhookUrlDomain = 'lifeplus-line.wifiotg.com';
            }

            this.webhookUrl = `https://${data.webhookUrlDomain}/line/general/${data.lineChannelId}/code/${data.randomCode}`;

              this.runNext();
          } else {
            throw new Error(
                "無法取得正確快一點上系統串接相關資訊 (webhook網域, randoemCode等)"
              );
          }


        })
        .catch((e) => {
          if (e.response) {
            e.response.json().then(function (err) {
              if (err.error) {
                self.responseMessages.push(err.error);
              } else {
                self.responseMessages.push(err);
              }
            });
          } else {
            self.responseMessages.push({
              message: e.message,
              stack: e.stack,
            });
          }
          self.blockAll = false;
        });
    },
    wizardWorkerHandler() {
      ++this.shopCount;
      if (this.accounts[this.shopCount]) {
        this.step = 2;
        this.responseMessages.push({
          type: "info",
          message: `成功開店 - 立即加入測試看看 ${this.botInfo.addFriendUrl}`,
        });
        this.responseMessages.push({
          type: "info",
          message: `偵測到還有店家要開店在此Provder，按下右鍵繼續`,
        });
      } else {
        this.responseMessages.push({
          type: "info",
          message: `開店完畢 - 立即加入測試看看 ${this.botInfo.addFriendUrl}`,
        });
      }
    },
    // enableRichmenu() {
    //   let self = this;
    //   this.blockAll = true;
    //   this.responseMessages.push({
    //     type: "info",
    //     message: `更新Richmenu - ${this.account.richmenu}`,
    //   });
    //   fetch(`accounts/${this.accountId}/richmenus`, {
    //     method: "POST",
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       fileName: this.account.richmenu,
    //     }),
    //   })
    //     .then((response) => {
    //       if (!response.ok) {
    //         let err = new Error(response.statusText);
    //         err.response = response;
    //         throw err;
    //       }
    //       return response.json();
    //     })
    //     .then((data) => {
    //       this.responseMessages.push({
    //         type: "info",
    //         message: JSON.stringify(data, null, 2),
    //       });

    //       this.runNext();

    //       this.blockAll = false;
    //     })
    //     .catch((e) => {
    //       if (e.response) {
    //         e.response.json().then(function (err) {
    //           if (err.error) {
    //             self.responseMessages.push(err.error);
    //           } else {
    //             self.responseMessages.push(err);
    //           }
    //         });
    //       } else {
    //         self.responseMessages.push({
    //           message: e.message,
    //           stack: e.stack,
    //         });
    //       }
    //       self.blockAll = false;
    //     });
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
